import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import {
  checkIfUserNameExist,
  mobileVerification,
  registerUser,
  sendOtpToEmail,
  sendOtpToMobile,
  verifyEmailOtp,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { APP_CONST, AFF_KEY_LS } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import RegisterBanner from "../../../assets/images/banner/Registerbanner-mob.webp";
import Whatsapp from "../../../assets/images/icons/social/Whatsapp.svg";
// import WtspChannel from "../../../assets/images/icons/social/Whatsapp.svg";
// import Telegram from "../../../assets/images/icons/social/Telegram.svg";
// import Instagram from "../../../assets/images/icons/social/Instagram.svg";
// import Facebook from "../../../assets/images/icons/social/facebook.svg";
// import Twitter from "../../../assets/images/icons/social/Twitter.svg";
// import YouTube from "../../../assets/images/icons/YouTube.png";
import PhoneInput from "react-phone-input-2";
import { FiEye, FiEyeOff } from "react-icons/fi";
import UseAppendScript from "../../../hooks/useAppendScript";
import useAppendNewScript from "../../../hooks/useAppendNewScript";
// import LoginLeftPart from "../../../assets/images/modal.gif";

/**
 *
 * @param {string} mobileNumber
 */
const getParsedMobile = (mobileNumber) => {
  const phoneNumber = parsePhoneNumber("+" + mobileNumber);
  return {
    mobile: phoneNumber?.nationalNumber || "",
    country_code: phoneNumber?.countryCallingCode | "",
  };
};

const RegisterModal = ({
  show,
  handleClose,
  handleModalShow,
  agentCode: agentCodeProp,
}) => {
  const validationMessages = [
    { text: "at least 8 symbols", key: 1 },
    { text: "at least 1 digit (0-9)", key: 2 },
    { text: "at least 1 lowercase characters (a-z)", key: 3 },
    { text: "at least 1 uppercase characters (A-Z)", key: 4 },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPasswordValidtions, setShowPasswordValidations] = useState(false);
  const [validationIndex, setValidationIndex] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const appendScript = UseAppendScript();
  const { appendScript: addScript } = useAppendNewScript({
    scriptId: "complt-register",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [referalCode, setReferalCode] = useState(location?.state?.referalCode);
  const [isReffered, setIsReffered] = useState(false);
  const [cookies, setCookie] = useCookies(["refferal"]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agentCode, setAgentCode] = useState(agentCodeProp);
  const [agentCookies, setAgentCookie] = useCookies(["agentCode"]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtpValue] = useState("");
  const [userNameConfig, setUserNameConfig] = useState({
    isUserNameExist: false,
    message: "User Name is available",
  });
  const affId = localStorage.getItem(AFF_KEY_LS);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });

  const [isLoading, setIsLoading] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;

  const sendEmailOTPSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!Boolean(email.email) || email.email == "") {
      return;
    }

    const response = await sendOtpToEmail(email);
    if (response) {
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || "OTP sent"
      );
    }
    setIsLoading(false);
  };

  // const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState("");

  const verifyEmailOtpSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      return;
    }
    setIsVerifying(true);
    const response = await verifyEmailOtp({
      email: email?.email,
      otp: otp,
    });
    if (response) {
      setIsEmailVerified(true);
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || "OTP Verified"
      );
    }
    setIsVerifying(false);
  };
  const checkForPasswordValidations = (e) => {
    const password = e.target.value;
    let fulfilledindex = [];
    if (password.length >= 8) {
      fulfilledindex.push(1);
    }
    if (/\d/.test(password)) {
      fulfilledindex.push(2);
    }
    const smallAlp = new RegExp("(?=.*[a-z])");
    if (smallAlp.test(password)) {
      fulfilledindex.push(3);
    }
    const capAlp = new RegExp("(?=.*[A-Z])");
    if (capAlp.test(password)) {
      fulfilledindex.push(4);
    }
    setValidationIndex(fulfilledindex);
  };

  useEffect(() => {
    if (referalCode) {
      setCookie("code", referalCode);
      setReferalCode(referalCode);
      setIsReffered(true);
    } else if (cookies?.code) {
      setReferalCode(cookies.code);
      setIsReffered(true);
    }
  }, [cookies, referalCode]);

  useEffect(() => {
    if (agentCode) {
      setAgentCookie("agent", agentCode);
    } else if (agentCookies?.agent) {
      setAgentCode(agentCookies?.agent);
    }
  }, [agentCookies, agentCode]);

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { name, username, password, confirmPassword } = dataToValidate;
    const newErrors = {};
    // if (!name || name === "") {
    //   newErrors.name = "Name cannot be empty";
    // }
    if (!username || username === "") {
      newErrors.userName = "User name cannot be empty";
    }
    if (username && (username.length < 4 || username.length > 15)) {
      newErrors.userName = "Username must be 4 to 15 characters.";
    }
    if (!/^[A-Za-z0-9 ]+$/.test(username)) {
      newErrors.userName = "Special characters are not allowed in username.";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = "Password must be 8 to 20 characters.";
    }
    // if (!confirmPassword || confirmPassword === "") {
    //   // newErrors.confirmPassword = "Confirm password cannot be empty";
    // } else if (password !== confirmPassword) {
    //   // newErrors.confirmPassword = "Password and Confirm password must be same";
    // }

    setErrors(newErrors);
    return newErrors;
  };

  const scriptLoad = () => {
    appendScript(`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '570847040189148');
fbq('init', '1579555345780712');
fbq('init', '1265942443607417');
fbq('init', '1439285079537929');
fbq('trackCustom', 'Goa777CompleteRegistration');`);

    addScript(`
    !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '716009664397945');
fbq('track', 'CompleteRegistration');
    `);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorsData = validateData();

    if (Object.keys(errorsData).length > 0) {
      return;
    }

    let dataToSend = { ...formData };
    if (isEmailOtpRequired) {
      if (!Boolean(mobileNumber)) {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, "Mobile is required");
      }
      dataToSend = {
        ...dataToSend,
        ...getParsedMobile(mobileNumber),
        email: email?.email,
      };
    } else {
      dataToSend.mobile = registerConfig?.mobileDetails?.mobile;
      dataToSend.country_code = registerConfig?.mobileDetails?.country_code;
    }

    dataToSend.name = formData?.username;

    delete dataToSend.confirmPassword;
    if (agentCode) {
      dataToSend.agent_code = agentCode;
    }

    // Send tracking id , if exist
    if (affId) {
      dataToSend.affId = affId;
    }

    dispatch(
      registerUser(
        {
          ...dataToSend,
          typeId: 3,
          parentId: 81026,
          // mobile: registerConfig.mobileDetails?.mobile,
          // country_code: registerConfig.mobileDetails.country_code,
        },
        () => scriptLoad()
      )
    );
    // checkIfExistingUserDetails(formData);
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  const [registerConfig, setRegisterConfig] = useState({
    isOtpEnabled: useSelector((state) => state?.app?.appDetails?.OTP) === 0,
    mobileDetails: {},
    isSendingOtp: false,
    isVerifyingOtp: false,
    isOtpSent: false,
    isOtpVerified: false,
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleRegisterConfigChange = (config) => {
    setRegisterConfig((p) => ({ ...p, ...config }));
  };

  const sendOtp = () => {
    handleRegisterConfigChange({
      isSendingOtp: true,
    });
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    payload.mobile = phoneNumber.nationalNumber;
    payload.country_code = phoneNumber.countryCallingCode;

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        handleRegisterConfigChange({
          mobileDetails: payload,
          isOtpSent: true,
          isSendingOtp: false,
        });
        if (res?.data?.error === false) {
          Toaster(
            APP_CONST.TOAST_TYPE.SUCCESS,
            res?.data?.message || "OTP sent"
          );
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        handleRegisterConfigChange({
          isSendingOtp: false,
        });
      });
  };

  const verifyOtp = () => {
    handleRegisterConfigChange({
      isVerifying: true,
    });
    dispatch(mobileVerification({ ...registerConfig.mobileDetails, otp }))
      .then((res) => {
        handleRegisterConfigChange({
          isVerifying: false,
          isOtpVerified: true,
        });
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP verified");
      })
      .catch((err) => {
        handleRegisterConfigChange({
          isVerifying: false,
        });
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  const checkUserName = async () => {
    if (formData?.username) {
      const response = await checkIfUserNameExist({
        username: formData?.username,
      });
      if (response && response?.data?.error === false) {
        setUserNameConfig({
          userNameExist: false,
          message: "username is available",
        });
      } else {
        setUserNameConfig({
          isUserNameExist: true,
          message: "username is already taken",
        });
      }
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal register"}
      onHide={() => {
        console.log("working");
      }}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      ></Modal.Header>

      <Modal.Body>
        {/* <Modal.Title className="mb-4">Registration</Modal.Title> */}
        <div className="inner-wrapper">
          <div className="left-banner-register d-none d-lg-block"></div>
          <div className="right-content">
            <div className="register-banner d-lg-none">
              <img src={RegisterBanner} alt="sign up banner pinkybet" />
            </div>
            <div className="back-demo">
              <h2 className="title">Registration</h2>
              <div className="demobutton">
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Whatsapp} alt="whatsapp" />
                </a>
              </div>
            </div>
            <div className="form-steps">
              <Form>
                {/* <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={"text"}
                name="name"
                placeholder="Name*"
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.name}
              </Form.Control.Feedback>
            </Form.Group> */}
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Username*"
                    onChange={handleChange}
                    isInvalid={!!errors.userName}
                    // onBlur={checkUserName}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors?.userName}
                  </Form.Control.Feedback>
                </Form.Group>
                {/* <div
              className="user_avail"
              style={
                userNameConfig.isUserNameExist
                  ? { color: "#bc2f3e", fontSize: "12px" }
                  : { color: "#198754", fontSize: "12px" }
              }
            >
              {formData?.username && userNameConfig.message}
            </div> */}
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password*"
                    autoComplete="new-password"
                    onChange={(e) => {
                      handleChange(e);
                      checkForPasswordValidations(e);
                    }}
                    isInvalid={!!errors.password}
                    onFocus={() => {
                      setShowPasswordValidations(true);
                    }}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((p) => !p)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>
                {/* <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password*"
                onChange={handleChange}
                isInvalid={!!errors.confirmPassword}
                onFocus={() => {
                  setShowPasswordValidations(true);
                }}
              />
              <span
                className="icon"
                onClick={() => setShowConfirmPassword((p) => !p)}
              >
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group> */}
                {showPasswordValidtions && (
                  <div className="password-note">
                    <ul>
                      {validationMessages.map((item, index) => {
                        const result = validationIndex.find(
                          (i) => i === item.key
                        );
                        return (
                          <li
                            className={result ? "pwd-validation-message" : ""}
                          >
                            {item?.text}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
                <Form.Group
                  className="position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={"text"}
                    name="agent_code"
                    placeholder="Please enter Referral Code"
                    value={agentCode}
                    onChange={(e) => setAgentCode(e.target.value)}
                  />
                </Form.Group>

                {!isEmailOtpRequired && (
                  <>
                    {" "}
                    <div className="get-otp mb-2">
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <PhoneInput
                          country={"in"}
                          countryCodeEditable={false}
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          inputStyle={{ width: "100%" }}
                          onChange={(phone) => {
                            setMobileNumber(phone);
                          }}
                        />
                      </Form.Group>

                      <Button
                        variant="primary"
                        onClick={sendOtp}
                        className="registerButton"
                        disabled={
                          registerConfig.isSendingOtp ||
                          userNameConfig.isUserNameExist === true
                        }
                      >
                        {registerConfig.isSendingOtp ? "Loading.." : "Submit"}
                      </Button>
                      {registerConfig?.isOtpEnabled && (
                        <p className="otpnote">
                          <span>Note:</span> user can request a new otp after
                          every five minutes.
                        </p>
                      )}
                    </div>
                    {registerConfig?.isOtpEnabled && (
                      <div className="verify-otp">
                        <Form.Group
                          className="mb-1 position-relative"
                          controlId="formBasicPassword"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Enter OTP*"
                            className="verifyOtp"
                            onChange={(e) => setOtpValue(e.target.value)}
                          />
                        </Form.Group>

                        <Button
                          variant="primary"
                          onClick={verifyOtp}
                          disabled={
                            registerConfig.isVerifyingOtp ||
                            !registerConfig.isOtpSent ||
                            !otp
                          }
                        >
                          {!registerConfig.isOtpVerified
                            ? !registerConfig.isVerifyingOtp
                              ? "VERIFY OTP"
                              : "SUBMITTING"
                            : "VERIFIED"}
                        </Button>
                      </div>
                    )}
                  </>
                )}

                {isEmailOtpRequired && (
                  <>
                    <div className="get-otp mb-2">
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <PhoneInput
                          country={"mx"}
                          countryCodeEditable={false}
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          inputStyle={{ width: "100%" }}
                          onChange={(phone) => {
                            setMobileNumber(phone);
                          }}
                        />
                      </Form.Group>
                    </div>
                    <Form>
                      <Form.Group
                        className="mb-3 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="email"
                          placeholder="Enter email*"
                          value={email.email}
                          onChange={(e) => setEmail({ email: e.target.value })}
                        />
                      </Form.Group>

                      <Button
                        variant="primary"
                        // type="submit"
                        onClick={sendEmailOTPSubmit}
                        className="loginbtn"
                        disabled={isLoading || !Boolean(email.email)}
                      >
                        {isLoading ? "Loading.." : "Send OTP to Email"}
                      </Button>
                    </Form>
                    <Form>
                      <Form.Group
                        className="mb-1 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="text"
                          value={otp}
                          placeholder="Enter OTP*"
                          onChange={(e) => setOtpValue(e.target.value)}
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        disabled={isVerifying}
                        onClick={verifyEmailOtpSubmit}
                      >
                        {!isVerifying ? "VERIFY" : "SUBMITTING"}
                      </Button>
                    </Form>
                  </>
                )}
                <div style={{ marginBottom: "10px" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "end",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                    />
                    <span style={{ fontSize: "10px", color: "#fff" }}>
                      By clicking Register, you agree to our{" "}
                      <a
                        href="/termss"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Service
                      </a>{" "}
                      and that you have read our, I hereby authorize to send
                      notifications on SMS/ RCS Messages / Promotional/
                      Informational messages.
                    </span>
                  </label>
                </div>
                <Button
                  variant="primary"
                  type="submit"
                  className="register mb-3"
                  onClick={handleSubmit}
                  disabled={
                    !isChecked ||
                    (isEmailOtpRequired && !isEmailVerified) ||
                    registerConfig?.isOtpEnabled
                      ? !registerConfig?.isOtpVerified
                      : !registerConfig?.isOtpSent
                  }
                >
                  Register
                </Button>
              </Form>

              <div className="account-signin-signup register">
                <span>Already have an account?</span>
                <a
                  href="#"
                  onClick={() => {
                    handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                    handleClose(APP_CONST.AUTH_MODAL.REGISTER);
                  }}
                >
                  <p>Login</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
